/**
 * @generated SignedSource<<3146f23602f7f81d2a8568ac5ba5d3d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GroupMemberListItem_member$data = {
  readonly displayName: string | null | undefined;
  readonly email: string | null | undefined;
  readonly id: string;
  readonly username: string;
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_user">;
  readonly " $fragmentType": "GroupMemberListItem_member";
};
export type GroupMemberListItem_member$key = {
  readonly " $data"?: GroupMemberListItem_member$data;
  readonly " $fragmentSpreads": FragmentRefs<"GroupMemberListItem_member">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GroupMemberListItem_member",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Avatar_user"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "76406dfb8ee3dfec695b9b0707fd563d";

export default node;
